export enum DateRangeOptions {
    Last30Days = 'Last_30_Days',
    Last90Days = 'Last_90_Days',
    Last6Months = 'Last_6_Months',
    Last12Months = 'Last_12_Months',
    Last24Months = 'Last_24_Months',  // Equivalent to 2 Years
    Last36Months = 'Last_36_Months',  // Equivalent to 3 Years
    Last48Months = 'Last_48_Months',  // Equivalent to 4 Years
    AllTime = 'All_Time'
}
